import { AxiosInstance } from "axios"
import { Debtor, DebtorDetails } from "./adminInvoicingTypes"

export enum SupportInvoicingQuery {
    DEBTORS_INVOICING_BASIS = "debtors-invoicing-basis-for-support",
    DEBTORS_LIST = "debtors-for-support",
}

type DebtorsParams = Readonly<{}>

export type DebtorsSupportAdminResponse = Readonly<{
    debtors: Debtor[]
}>

export async function fetchDebtors(
    {}: DebtorsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DebtorsSupportAdminResponse> {
    const { data } = await axios.get(`/accounting/debtors`, {
        signal,
    })
    return data
}

type DebtorsInvoicingBasisParams = Readonly<{
    startDate: string
    endDate: string
    debtorId?: number | null
}>

export type DebtorsInvoicingBasisResponse = Readonly<{
    debitors: DebtorDetails[]
}>

export async function fetchDebtorsInvoicingBasis(
    { startDate, endDate, debtorId }: DebtorsInvoicingBasisParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DebtorsInvoicingBasisResponse> {
    const { data } = await axios.get(`/debitors/invoicing/basis`, {
        params: {
            startDate,
            endDate,
            debtorId,
        },
        signal,
    })
    return data
}

type DebtorsInvoicingBasisDetailsParams = Readonly<{
    debtorsId: number
}>

export type DebtorsInvoicingBasisDetailsResponse = Readonly<{
    debtors: DebtorDetails[]
}>

export async function fetchDebtorsInvoicingBasisDetails(
    { debtorsId }: DebtorsInvoicingBasisDetailsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DebtorsInvoicingBasisDetailsResponse> {
    const { data } = await axios.get(`/debitors/${debtorsId}/invoicing/basis/`, {
        signal,
    })
    return data
}
